import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import i18n from "i18next";
import { config } from "../config";
import MobMenu from "./mobMenu";
import CatalogIcon from "../images/menu-arrow.png";
import LanguageSwitcher from "./Topbar/language";
import CustomMenu from "./CustomMenu/CustomMenu";
import MiddleMenu from "./CustomMenu/middleMenu";
import UserBar from "./userBar";
import { getsJoomlaMenu } from "../actions/menu";
class JoomlaOffcanvasMenu extends Component {
  static propTypes = {
    isShowLoaderMenu: PropTypes.bool,
    joomlaMenu: PropTypes.object,
  };
  constructor(props) {
    super(props);
    this.state = {
      isShowCatalogMenu: true,
      isShowProfileMenu: false,
      isShowSubMenu: false,
      subMenuActiveClass: ''
    };
  }
  componentDidMount() {
    this.props.getsJoomlaMenu('menu-desktop-' + this.props.i18n.language);
  }
  handleShowCatalog() {
    this.setState({ isShowCatalogMenu: !this.state.isShowCatalogMenu });
  }
  handleShowProfile() {
    this.setState({ isShowProfileMenu: !this.state.isShowProfileMenu });
  }
  handleShowSubMenu() {
    this.setState({ isShowSubMenu: !this.state.isShowSubMenu });
    this.setState({subMenuActiveClass: !this.state.isShowSubMenu ? 'mob-subnav-active':''});
  }

  subMenu = parentId => {

    const subMenuList = this.props.joomlaMenu.joomla.filter(val => {
      return val.parentId == parentId
    })
    
    if (subMenuList.length) {

      const list = 
        <ul className="mob-header__menu-sub-nav uk-nav-sub">
          {Object.keys(subMenuList).map((id, inx) => {
            return (
              <li key={'submenu'+id}>
                <a
                  className="mob-menu-sub-nav__link"
                  href={config.siteUrl + subMenuList[inx].path}
                >
                  {subMenuList[inx].title}
                </a>
              </li>
            )
          })
          }
        </ul>
     

      return list;
    }

  }


  render() {
    const { t } = this.props;

    return (
      <div
        id="offcanvas-menu"
        uk-offcanvas="overlay: true"
        className="uk-offcanvas uk-offcanvas-overlay"
      >
        <div className="uk-offcanvas-bar uk-offcanvas-bar-animation uk-offcanvas-slide">
          <div className="mob-header-offcanvas__title">
            {t("menu")}
            <button
              className="uk-offcanvas-close"
              type="button"
              uk-close=""
            ></button>
          </div>
          <nav className="header-nav-mb__nav-list ">
            <ul className="uk-nav uk-nav-parent-icon ">
              {this.props.isShowLoaderMenu === false
                ? Object.keys(this.props.joomlaMenu.joomla).map((itm, key) => (
                    <div key={itm}>
                 
                      {key === 1 ? (
                        <>
                        
                          <li className="header-nav-mb__nav-list--item">
                            <a
                              className="mob-header__catalog-link"
                              href="#"
                              onClick={() => this.handleShowCatalog()}
                            >
                              {t("menu.catalog")}
                              <img
                                className={
                                  this.state.isShowCatalogMenu
                                    ? "mob-header__catalog-link-deactivate"
                                    : "mob-header__catalog-link-active"
                                }
                                src={CatalogIcon}
                                uk-svg=""
                              />
                            </a>
                            <MobMenu
                              showCatalog={this.state.isShowCatalogMenu}
                            />
                          </li>
                          {/* <CustomMenu />
                          <li>
                            <Link
                              className="header-nav-mb__nav-list--item"
                              to={`/products/${i18n.language}/promo/actions`}
                            >
                              {i18n.t("actions")}
                            </Link>
                          </li> */}
                          {/* <MiddleMenu /> */}
                        </>
                      ) : (
                       
                        this.props.joomlaMenu.joomla[itm].level === 1 &&
                        <li className="joom-menu" key={"jom-menu-" + itm}>
                          { console.log(this.props.joomlaMenu.joomla)}
                          <a
                          
                          className={this.subMenu(this.props.joomlaMenu.joomla[itm].id)&&'mob-subnav '+ this.state.subMenuActiveClass}
                          href={!this.subMenu(this.props.joomlaMenu.joomla[itm].id)?
                              config.siteUrl +
                              this.props.joomlaMenu.joomla[itm].alias:'#'
                            }
                          onClick={()=>this.handleShowSubMenu()}
                          >
                            {this.props.joomlaMenu.joomla[itm].title}
                          </a>
                          {this.state.isShowSubMenu&&this.subMenu(this.props.joomlaMenu.joomla[itm].id)}
                        </li>
                      )}
                    </div>
                  ))
                : "loading"}
            </ul>
          </nav>
          <div className="">
            <div
              className={`mob-header-offcanvas__account ${
                this.state.isShowProfileMenu ? "account-active" : ""
              }`}
              onClick={() => this.handleShowProfile()}
            >
              {t("menu.my_profile")}
            </div>
            <ul
              className={`mob-header__account-menu uk-nav-sub ${
                this.state.isShowProfileMenu ? "uk-display-block" : ""
              }`}
            >
              <li>
              <div className="uk-flex uk-flex-middle uk-flex-between@l">
              <UserBar />
            </div>
              </li>
              {/* <li>
                <Link to={"/products/" + i18n.language + "/wishlist/list/"}>
                  {t("wishlist")}
                </Link>
              </li>
              <li>
                <Link to={"/products/" + i18n.language + "/compare/list/"}>
                  {t("compare")}
                </Link>
              </li> */}
            </ul>
            {/* <div className="mob-header-offcanvas__lang">
              <LanguageSwitcher location={this.props.location} />
            </div> */}
          </div>
        </div>
      </div>
    );
  }
}
const menuList = withTranslation("translations")(JoomlaOffcanvasMenu);
const mapStateToProps = (store) => {
  const { joomlaMenu, isShowLoaderMenu } = store.menu;

  return {
    joomlaMenu: joomlaMenu,
    isShowLoaderMenu: isShowLoaderMenu,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getsJoomlaMenu: (menutype) => {
      dispatch(getsJoomlaMenu(menutype));
    },
  };
};

export default connect(mapStateToProps,mapDispatchToProps)(menuList);
